import { Bell } from "lucide-react";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";

// Push notifications temporarily disabled - requires VAPID server configuration
// TODO: Implement proper push notification server with valid VAPID keys
const PUSH_ENABLED = false;

export const PushNotificationManager = () => {
  const { userRole } = useAuth();

  // Only show for supervisors and admins
  if (userRole !== 'supervisor' && userRole !== 'admin') {
    return null;
  }

  if (!PUSH_ENABLED) {
    return (
      <Card className="opacity-60">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Bell className="w-5 h-5" />
            Notificaciones Push
            <span className="text-xs bg-muted px-2 py-1 rounded">Próximamente</span>
          </CardTitle>
          <CardDescription>
            Las notificaciones push estarán disponibles próximamente.
            Por ahora, las alertas se muestran dentro de la aplicación.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return null;
};
